import { InjectedRouter } from 'react-router';

import { CoachAvailabilityInput, CoachAvailabilityExceptionInput } from 'globalTypes';
import CoachingAvailabilityView from './components/CoachingAvailabilityView/CoachingAvailabilityView';
import CurrentUser from 'auth/CurrentUser';
import GetCoachAvailabilitiesAndTimezoneContainer from 'coaching/containers/GetCoachAvailabilitiesAndTimezoneContainer';
import IsRemindCoachContainer from 'coaching/containers/IsRemindCoachContainer';
import SetCoachAvailabilitiesContainer from 'coaching/containers/SetCoachAvailabilitiesContainer';
import SetCoachAvailabilityExceptionContainer from 'coaching/containers/SetCoachAvailabilityExceptionContainer';
import DeleteCoachAvailabilityExceptionContainer from 'coaching/containers/DeleteCoachAvailabilityExceptionContainer';
import React from 'react';
import { getWeeklyTimeframeISOStrings } from 'coaching/lib/timeIntervals';
import TimezoneHelper from 'lib/timezones';

type Props = {
  router: InjectedRouter;
};

type State = {
  timezone: string;
  weekOffset: number;
};

export default class CoachingAvailabilityContainer extends React.Component<Props, State> {
  state: State = {
    weekOffset: 0,
    // try and ascertain the user's timezone, and default to the first value
    // in the select options if we cannot
    timezone:
      TimezoneHelper.userTimezoneDefaultValue ?? TimezoneHelper.USTimezoneSelectOptions[0].value,
  };

  advanceWeekOffset = () => {
    this.setState({ weekOffset: this.state.weekOffset + 1 });
  };

  regressWeekOffset = () => {
    this.setState({ weekOffset: this.state.weekOffset - 1 });
  };

  render() {
    const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
    if (!user) {
      return null;
    }

    const userUuid = user.getUuid();
    const { startDateTime, endDateTime } = getWeeklyTimeframeISOStrings(this.state.weekOffset);
    const queryProps = {
      coachUuid: userUuid,
      startDateTime,
      endDateTime
    };

    return (
      <IsRemindCoachContainer userUuid={userUuid}>
        <GetCoachAvailabilitiesAndTimezoneContainer {...queryProps}>
          {({ loading, error, data }) => {
            return (
              <SetCoachAvailabilityExceptionContainer {...queryProps}>
                {({ setCoachingAvailabilityException }) => {
                  return (
                    <DeleteCoachAvailabilityExceptionContainer {...queryProps}>
                      {({ deleteCoachingAvailabilityException }) => {
                        return (
                          <SetCoachAvailabilitiesContainer {...queryProps}>
                            {({ setCoachingAvailability }) => {

                              const setCoachingAvailabilityFn = async (
                                input: CoachAvailabilityInput[],
                                timezone: string,
                                onMutate?: () => void
                              ) => {
                                await setCoachingAvailability({
                                  variables: {
                                    input,
                                    timezone,
                                    coachUuid: userUuid,
                                  },
                                });
                                if (onMutate) {
                                  onMutate();
                                }
                              };

                              const setCoachingAvailabilityExceptionFn = async (
                                input: CoachAvailabilityExceptionInput[],
                                timezone: string,
                                onMutate?: () => void
                              ) => {
                                await setCoachingAvailabilityException({
                                  variables: {
                                    input,
                                    timezone,
                                    coachUuid: userUuid,
                                  },
                                });
                                if (onMutate) {
                                  onMutate();
                                }
                              };

                              const deleteCoachingAvailabilityExceptionFn = async (
                                exceptionUuid: string
                              ) => {
                                await deleteCoachingAvailabilityException({
                                  variables: {
                                    exceptionUuid,
                                    coachUuid: userUuid,
                                  },
                                });
                              };

                              return (
                                <CoachingAvailabilityView
                                  weekOffset={this.state.weekOffset}
                                  onAdvanceWeekOffset={this.advanceWeekOffset}
                                  onRegressWeekOffset={this.regressWeekOffset}
                                  timezone={data?.coaching?.findCoachForUserUuid.coach.timezone!}
                                  loadingSchedule={loading}
                                  errorMessage={error?.message}
                                  existingAvailabilities={
                                    data?.coaching?.coachAvailability.availabilities
                                  }
                                  existingAvailabilityExceptions={
                                    data?.coaching?.coachAvailability.availabilityExceptions
                                  }
                                  setCoachingAvailability={setCoachingAvailabilityFn}
                                  setCoachingAvailabilityException={
                                    setCoachingAvailabilityExceptionFn
                                  }
                                  deleteCoachingAvailabilityException={
                                    deleteCoachingAvailabilityExceptionFn
                                  }
                                />
                              );
                            }}
                          </SetCoachAvailabilitiesContainer>
                        );
                      }}
                    </DeleteCoachAvailabilityExceptionContainer>
                  );
                }}
              </SetCoachAvailabilityExceptionContainer>
            );
          }}
        </GetCoachAvailabilitiesAndTimezoneContainer>
      </IsRemindCoachContainer>
    );
  }
}
